export default "__VITE_ASSET__0dqq5j6L__"